import { useCallback, useEffect, useState } from 'react';

/** 入力文字列を trim して遅延反映（検索欄の連打防止）。flush で即時反映。 */
export function useTppDebouncedTrim(
  input: string,
  delayMs = 280
): [debounced: string, flush: (next?: string) => void] {
  const [debounced, setDebounced] = useState(() => input.trim());

  const flush = useCallback(
    (next?: string) => {
      setDebounced((next ?? input).trim());
    },
    [input]
  );

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebounced(input.trim());
    }, delayMs);
    return () => window.clearTimeout(timer);
  }, [input, delayMs]);

  return [debounced, flush];
}
